import React, { ReactNode } from 'react'
import { MuiThemeWrapper } from './MuiTheme'
import { StyledThemeWrapper } from './StyledTheme'

export const ThemeWrapper = ({ children }: { children: ReactNode }) => (
  <MuiThemeWrapper>
    <StyledThemeWrapper>{children}</StyledThemeWrapper>
  </MuiThemeWrapper>
)
